import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "error", "warning", "minHeight", "minWidth", "display", "alignItems", "justifyContent"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { StencilConsumer } from "../../context";
import { View } from "../../layout";
import { FONT_SIZE } from "./constants";
import { jsx as ___EmotionJSX } from "@emotion/core";

var getIconColor = function getIconColor(_ref) {
  var error = _ref.error,
      warning = _ref.warning;
  if (error) return 'red70';
  if (warning) return 'yellow70';
  return 'neutral70';
};

var InputFooterIcon = function InputFooterIcon(_ref2) {
  var children = _ref2.children,
      _ref2$error = _ref2.error,
      error = _ref2$error === void 0 ? false : _ref2$error,
      _ref2$warning = _ref2.warning,
      warning = _ref2$warning === void 0 ? false : _ref2$warning,
      _ref2$minHeight = _ref2.minHeight,
      minHeight = _ref2$minHeight === void 0 ? 16 : _ref2$minHeight,
      _ref2$minWidth = _ref2.minWidth,
      minWidth = _ref2$minWidth === void 0 ? 16 : _ref2$minWidth,
      _ref2$display = _ref2.display,
      display = _ref2$display === void 0 ? 'flex' : _ref2$display,
      _ref2$alignItems = _ref2.alignItems,
      alignItems = _ref2$alignItems === void 0 ? 'center' : _ref2$alignItems,
      _ref2$justifyContent = _ref2.justifyContent,
      justifyContent = _ref2$justifyContent === void 0 ? 'center' : _ref2$justifyContent,
      transferProps = _objectWithoutProperties(_ref2, _excluded);

  return ___EmotionJSX(StencilConsumer, null, function (_ref3) {
    var selectors = _ref3.selectors;
    // Align to the center of the first line of text by making the height of the
    // wrapper equal to the line height of the text, and centering the icon vertically
    // in the wrapper.
    // Line height is specified as unitless so it must be multiplied by the font size
    // to get the absolute value.
    var lineHeight = selectors.lineHeight(FONT_SIZE);
    var fontSize = selectors.fontSize(FONT_SIZE);
    var height = "calc(".concat(lineHeight, " * ").concat(fontSize, ")");
    return ___EmotionJSX(View, _extends({
      height: height,
      minHeight: minHeight,
      minWidth: minWidth,
      display: display,
      alignItems: alignItems,
      justifyContent: justifyContent,
      color: getIconColor({
        error: error,
        warning: warning
      })
    }, transferProps), children);
  });
};

InputFooterIcon.displayName = 'InputFooterIcon';
InputFooterIcon.propTypes = _objectSpread(_objectSpread({}, View.propTypes), {}, {
  error: PropTypes.bool,
  warning: PropTypes.bool
});
export default InputFooterIcon;